<template>
  <div>
    <div
      class="tableDetail"
      v-for="(item, indexd) in tableData"
      :key="item.packId"
    >
      <div class="top" v-if="subPackageFlag == 1">
        <span class="name-par ccui-clearfix">
          <span class="name" :title="item.packName">{{ item.packName }}</span
          >{{ $t("page.content.QuotationInfo") }}
        </span>
        <!-- 包件要求 -->
        <span
          class="name"
          style="color:#0089EF"
          @click="openPackageDescription(item.packRequire)"
          >{{ $t("page.content.PackageDescription") }}</span
        >
        <!-- 流标状态 -->
        <span
          v-if="item.packStatus != '1'"
          class="name"
          style="color:red;font-size:14px"
        >
          <!--（已流标）-->
          {{ $t("page.content.droppedMark") }}
        </span>
      </div>
      <!-- <hr
        v-if="subPackageFlag == 1"
        style="border:1px solid #EDF2FC;width:100%"
      /> -->
      <div class="center">
        <p class="chlidName">
          <!-- 投标总金额(元) -->
          {{ $t("page.content.Totalamount") + "(" + unit + ")" }}：<span
            style="color:#FF142F "
            >{{ item.packBidTotalAmt }}</span
          >
        </p>
      </div>
      <div class="ccui-multifunctional-table-wrapper">
        <!-- <div class="tableBox"> -->
        <ux-grid
          :data="item.sscBidMatInfoBOS"
          widthResize
          border
          show-overflow
          class="ccui-multifunctional-table"
          max-height="798"
          :scrollX="{ gt: -1, oSize: 0 }"
        >
          <!-- 序号 -->
          <ux-table-column
            type="index"
            :title="$t('page.content.No')"
            width="55"
            :resizable="true"
            fixed="left"
            :key="1"
          ></ux-table-column>
          <!-- 设备物质名称 -->
          <ux-table-column
            field="matName"
            :title="$t('page.content.Item')"
            :min-width="languagezh_cn ? 120 : 280"
            show-overflow-tooltip
            :resizable="true"
            fixed="left"
            :key="2"
          ></ux-table-column>
          <!-- 设备物质说明 -->
          <ux-table-column
            field="matDesc"
            :title="$t('page.content.ItemDescription')"
            :min-width="languagezh_cn ? 120 : 280"
            show-overflow-tooltip
            :resizable="true"
            fixed="left"
            :key="3"
          ></ux-table-column>
          <!-- 数量 -->
          <ux-table-column
            field="convPurchaseNum"
            :title="$t('page.content.QTY')"
            min-width="120"
            show-overflow-tooltip
            :resizable="true"
            :key="4"
          ></ux-table-column>
          <!-- 单位 -->
          <ux-table-column
            field="convMeasureUnitName"
            :title="$t('page.content.Unit')"
            min-width="100"
            show-overflow-tooltip
            :resizable="true"
            :key="5"
          ></ux-table-column>
          <ux-table-column
            show-header-overflow
            :title="items.priceItem"
            :resizable="true"
            min-width="180"
            v-for="(items, indexs) in item.sscBidMatInfoBOS[0]
              .sscSupPriceItemBOS"
            :key="items.bidPriceItemId + indexd + columnNewIndex + indexs"
          >
            <template slot-scope="{ row, rowIndex }">
              <el-input
                v-if="type == 1"
                v-limitdecimal.two.maxPrice.negative
                :placeholder="$t('page.content.enter')"
                v-model.trim="row.sscSupPriceItemBOS[indexs].convPriceAmount"
                @blur="e => numBlur(row, rowIndex, indexs, indexd, e)"
                maxlength="15"
                :key="rowIndex + indexs + indexd"
                :readonle="subPackageFlag == 1 && item.packStatus != '1'"
                :disabled="subPackageFlag == 1 && item.packStatus != '1'"
              ></el-input>
              <span v-else>
                {{ row.sscSupPriceItemBOS[indexs].convPriceAmount }}</span
              >
            </template>
          </ux-table-column>
          <!-- 综合单价（元） -->
          <ux-table-column
            field="comUnitPrice"
            :title="$t('page.content.UnitPrice') + '(' + unit + ')'"
            :min-width="languagezh_cn ? 170 : 260"
            v-limitdecimal.two
            show-overflow-tooltip
            :resizable="true"
            :key="6"
          >
            <template slot-scope="{ row }">{{
              row.comUnitPrice !== "" ? row.comUnitPrice.toString() : ""
            }}</template>
          </ux-table-column>
          <!-- 小计 -->
          <ux-table-column
            field="totalPrice"
            :title="$t('page.content.Total') + '(' + unit + ')'"
            :min-width="languagezh_cn ? 140 : 260"
            show-overflow-tooltip
            :resizable="true"
            :key="7"
          >
          </ux-table-column>
        </ux-grid>
        <!-- </div> -->
      </div>
    </div>
    <el-dialog
      width="400px"
      :title="$t('page.content.PackageDescription')"
      @close="close"
      :visible="PackageDescriptionDialog"
    >
      <div class="PackageDescription">
        {{ this.packageDescription }}
      </div>
    </el-dialog>
  </div>
</template>
<script>
import BigNumber from "bignumber.js";
import Cookies from "js-cookie";
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      }
    },
    // index: {
    //   type: Number,
    //   default: 1
    // },
    // name: {
    //   type: String,
    //   default: "包件名称"
    // },
    type: {
      type: Number,
      default: 1
    },
    unit: {
      type: String,
      default: window.$t("page.content.yuan")
    }
  },
  mounted() {
    this.subPackageFlag = JSON.parse(sessionStorage.getItem("subPackageFlag"));
  },
  data() {
    return {
      total: 0,
      columnNewIndex: 0,
      subPackageFlag: "",
      PackageDescriptionDialog: false,
      packageDescription: ""
    };
  },
  computed: {
    languagezh_cn() {
      return (Cookies.get("language") || "zh-cn") === "zh-cn";
    }
  },
  methods: {
    numBlur(row, $index, indexs, indexd, e) {
      //debugger;
      e.target.value = e.target.value ? e.target.value.replace(/^00/, "0") : ""; //开头连续两个0，去掉一个
      e.target.value = e.target.value ? e.target.value.replace(/^\./g, "") : ""; //开头小数点，去掉
      e.target.value = e.target.value
        ? e.target.value.replace(/^\.{2,}/g, ".")
        : ""; //两个小数点，保留一个
      e.target.value = e.target.value
        ? e.target.value.replace(/^-{2,}/g, "-")
        : ""; //两个负号，保留一个
      e.target.value = e.target.value
        ? e.target.value.replace(/^-\./, "-")
        : ""; //符号后连小数点，去掉小数点
      e.target.value = e.target.value
        ? isNaN(Number(e.target.value).toFixed(2))
          ? ""
          : Number(e.target.value).toFixed(2)
        : "";
      //计算价格
      let p = 0;
      row.sscSupPriceItemBOS[indexs].convPriceAmount = e.target.value;
      console.log(row.sscSupPriceItemBOS, e.target.value);
      row.sscSupPriceItemBOS.forEach((vv, ii) => {
        p = window.$computeUtil.getPlus(p, vv.convPriceAmount || 0);
        if (ii == indexs) {
          //判断是否报价
          if (vv.convPriceAmount === "") {
            //this.tableData[indexd]["isBid"] = false;
          } else {
            this.tableData[indexd]["isBid"] = true;
          }
          // this.tableData[indexd]["isBid"] = true;
        }
      });

      let news = row.sscSupPriceItemBOS.filter(e => e.convPriceAmount == "");
      let emptyAll = row.sscSupPriceItemBOS.length == news.length;
      if (emptyAll) {
        this.tableData[indexd].sscBidMatInfoBOS[$index]["isBid"] = false;
        let childArr = this.tableData[indexd].sscBidMatInfoBOS;
        let childArr_noBid = childArr.filter(x => x.isBid !== true);
        if (childArr_noBid.length === childArr.length) {
          this.tableData[indexd]["isBid"] = false; //全部为空都不报价 的时候才为false
        }
      } else {
        this.tableData[indexd].sscBidMatInfoBOS[$index]["isBid"] = true;
        this.tableData[indexd]["isBid"] = true;
      }
      this.$set(
        this.tableData[indexd].sscBidMatInfoBOS[$index],
        "comUnitPrice",
        emptyAll ? "" : new BigNumber(p).toFixed(2)
      );
      let vv = window.$computeUtil.getMultiplyTwo(
        row.convPurchaseNum,
        row.comUnitPrice
      );
      this.$set(
        this.tableData[indexd].sscBidMatInfoBOS[$index],
        "totalPrice",
        emptyAll ? "" : vv
      );
      this.tableData.forEach((item, index) => {
        item.packBidTotalAmt = 0;
        let priceArr = item.sscBidMatInfoBOS.map(vvv => {
          return {
            num: vvv.convPurchaseNum,
            price: vvv.comUnitPrice
          };
        });
        let priceNullArr = priceArr.filter(ex => ex.price === "");
        if (priceNullArr.length === priceArr.length) {
          item.packBidTotalAmt = ""; //都是空的话 投标总金额为空
        } else {
          let priceArr1 = priceArr.map(vvv1 => {
            return {
              num: vvv1.num || 0,
              price: vvv1.price || 0
            };
          });
          item.packBidTotalAmt = window.$computeUtil.getPlusTwo(priceArr1);
        }
        // item.sscBidMatInfoBOS.forEach(vvv => {
        //   debugger
        //   item.packBidTotalAmt = window.$computeUtil.getPlusTwo({num:vvv.convPurchaseNum,price:vvv.comUnitPrice}, , );
        //   debugger
        //   if (index == indexd) {
        //     this.$set(
        //       this.tableData[indexd],
        //       "packBidTotalAmt",
        //       item.packBidTotalAmt
        //     );
        //   }
        // });
      });
    },
    openPackageDescription(packRequire) {
      this.PackageDescriptionDialog = true;
      this.packageDescription = packRequire;
    },
    close() {
      this.PackageDescriptionDialog = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.tableDetail {
  padding-bottom: 10px;
  border: 1px solid #edf2fc;
  margin-top: 15px;
  .top {
    display: flex;
    align-items: center;
    padding: 0px 10px;
    color: #4a4a4a;
    border-bottom: 1px solid #edf2fc;
    height: 40px;
    .name-par {
      padding-right: 20px;
      font-size: 14px;
      word-break: break-all;
    }
    .name {
      max-width: 300px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      float: left;
    }
  }
  .center {
    padding: 10px 10px;
    color: #4a4a4a;
    font-size: 14px;
  }
  .footer {
    padding: 10px 10px;
    color: #4a4a4a;
    font-size: 14px;
    .chlidName {
      padding-bottom: 10px;
    }
    .tableBox {
      padding: 0px 20px;
    }
  }
}
/deep/.el-table__row {
  line-height: 36px;
  height: 36px;
}
.packBox {
  display: flex;
  justify-content: center;
  height: 400px;
}
.PackageDescription {
  // width: 400px;
  height: 400px;
  display: flex;
  justify-content: center;
}
/deep/.el-table {
  border-collapse: collapse;
}
/deep/.el-table td,
.el-table th.is-leaf {
  border-right: 1px solid #edf2fc !important;
}
/deep/.ccui-multifunctional-table-wrapper {
  padding: 0px 20px;
  .el-table__header th {
    border-right: 1px solid #edf2fc !important;
  }
}
</style>
